import { rtkApi as postV2AuthSlideV3Confirm } from '#adapter/api/auth/v2/auth/slide-v3-confirm';
import { rtkApi as postV2AuthSlideV3 } from '#adapter/api/auth/v2/auth/slide-v3';

import type { SeparateAuthBaseApiType } from './separate-api-auth';

/*
    Подробное описание взаимодействия с `injectEndpoints` можно посмотреть по ссылке.

    https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting#injectendpoints
*/
export const injectEndpoints = (api: SeparateAuthBaseApiType) => {
    return api.injectEndpoints({
        endpoints: (build) => ({
            check: build.mutation<{ accessToken?: string, userID?: number, employeeID?: number, sessionID?: string } | null, void>({
                queryFn: async (arg, { dispatch }) => {
                    if(!localStorage.getItem(String(import.meta.env.APP_ACCESS_TOKEN_KEY))) {
                        const slide = await dispatch(postV2AuthSlideV3.endpoints.postV2AuthSlideV3.initiate({})).unwrap();

                        if(slide.result === 0 && 'payload' in slide) {
                            const { result, error } = await dispatch(postV2AuthSlideV3Confirm.endpoints.postV2AuthSlideV3Confirm.initiate({
                                body: {
                                    sticker: slide.payload.sticker
                                }
                            })).unwrap();

                            if(result === 0) {
                                localStorage.setItem(String(import.meta.env.APP_ACCESS_TOKEN_KEY), slide.payload.accessToken);

                                return {
                                    data: {
                                        accessToken: slide.payload.accessToken
                                    }
                                };
                            }
                            // Если сломались на confirm
                            const errMsg = typeof error === 'string' ? error : 'No token';

                            return { error: { status: 'FETCH_ERROR', error: errMsg } };
                        }
                        // Если сломались на auth
                        const errMsg = 'error' in slide ? slide.error : 'No token';

                        return { error: { status: 'FETCH_ERROR', error: errMsg } };
                    }

                    return { data: null };
                }
            })
        })
    });
};
